import React from 'react';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../commons/texts';
import { Divider } from '@mui/material';

export const CrearCotizacion = () => {
  return (
    <>
      <BreadCrumbsAndTitle
        title="Crear cotizacion"
        mainModule="ordenes de servicio"
        parent="Crear cotizacion"
        action=""
      />
      <AlertsInformativos type="info" title="info" content={alertInformativo.cotizaciones} />
      <Divider sx={{ marginBottom: 5 }} />
    </>
  );
};
